import React from 'react';
import { GridFilterInputValueProps } from '@mui/x-data-grid';
import SelectFilter, { SelectFilterOption } from './SelectFilter';

const companyTypeOptions: SelectFilterOption[] = [
  { value: '', label: 'All' },
  { value: 'assessor', label: 'Assessor' },
  { value: 'content_owner', label: 'Content Owner' },
  { value: 'vendor', label: 'Service Provider' },
];

export default function CompanyTypeFilter(props: GridFilterInputValueProps) {
  return <SelectFilter {...props} options={companyTypeOptions} />;
}
